import {Component, Input, OnInit} from '@angular/core';
import {SidebarNavHelper} from '../app-sidebar-nav.service';
import { INavData } from '../app-sidebar-nav';

@Component({
  selector: 'app-sidebar-nav-label, cui-sidebar-nav-label',
  templateUrl: './app-sidebar-nav-label.component.html'
})
export class AppSidebarNavLabelComponent implements OnInit {
  @Input()
  item: INavData = {};

  private classes: any = {
    'nav-label': true,
    active: true
  };
  private iconClasses: any = {};

  constructor(
    public helper: SidebarNavHelper
  ) { }

  ngOnInit() {
    this.iconClasses = this.helper.getIconClass(this.item);
  }

  getItemClass() {
    const itemClass: any = this.item.class;
    this.classes[itemClass] = !!itemClass;
    return this.classes;
  }
  getLabelIconClass() {
    if (typeof this.item.label !== 'undefined') {
      const variant: any = `text-${this.item.label.variant}`;
      this.iconClasses[variant] = !!this.item.label.variant;
      const labelClass: any = this.item.label.class;
      this.iconClasses[labelClass] = !!labelClass;
    }
    return this.iconClasses;
  }
}
